export const resolveActiveTuitionAcademicYear = (now = new Date()): string => {
  const year = now.getFullYear();
  const month = now.getMonth();
  const startYear = month >= 7 ? year : year - 1;
  return `${startYear}-${startYear + 1}`;
};

export const ACTIVE_TUITION_ACADEMIC_YEAR = resolveActiveTuitionAcademicYear();
